
export const dataAccountLinkInventory = [
    {
      Header: "INVENTORY LINKED ACCOUNTS",
      LinkAccount: [
        {
          linked_account_code: "LA10",
          description: "Lost & Damaged Goods",
          linked_account_name: "Inventory Linked Accounts",
        },
        {
          linked_account_code: "LA13",
          description: "Account for Overhead Production",
          linked_account_name: "Overhead Production",
        }
      ]
    }
  ]
